import ProfileStudium from './ProfileStudium';

export default ProfileStudium;
